import { projectsData } from "../../Components/Data/ProjectsData";

const Projects = () => {
  return (
    <div className="projects-page">
      <h1>All Projects</h1>
      <div className="projects-page-grid">
        {projectsData.map((project) => (
          <div key={project.id} className="project-card">
            <a href={project.link}>
                <img src={project.image} alt={project.title} />
                <div className="project-coverup">
                    <p>View {project.title} →</p>
                </div>
            </a>
            <h3>{project.title}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;